<template>
  <v-dialog
    v-model="dialog"
    :transition="isSmWidth ? 'dialog-right-transition' : 'dialog-transition'"
    scrollable
    persistent
    width="unset"
    :fullscreen="isSmWidth"
  >
    <component
      :is="componentName"
      :data="dialogData"
      :user-event-id="userEventId"
      :initial-read="initialRead"
      @close-dialog="closeDialog"
      @remove-notification="removeNotification"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { STORE_MODULES } from '@/js/plugins/store/modules/aimeos/actions/std-imports'
import MESSAGES_ACTIONS from '@/js/plugins/store/modules/messages/action-types.js'
import MESSAGES_GETTERS from '@/js/plugins/store/modules/messages/getter-types.js'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'

export default {
  name: 'MessagePreview',
  components: {
    BlockingreasonModalContent: () =>
      import(
        /* webpackChunkName: "BlockingreasonModalContent" */ '@/js/components/MessageCenter/modals/BlockingreasonModalContent.vue'
      ),
    BackorderModalContent: () =>
      import(
        /* webpackChunkName: "BackorderModalContent" */ '@/js/components/MessageCenter/modals/BackorderModalContent.vue'
      ),
  },
  props: {
    data: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapGetters(STORE_MODULES.APP, {
      isSmWidth: APP_GETTERS.IS_SM_WIDTH,
    }),
    ...mapGetters(STORE_MODULES.MESSAGES, {
      messagePreviewData: MESSAGES_GETTERS.MESSAGE_PREVIEW_DATA,
    }),
    dialogData() {
      return this.messagePreviewData?.data
    },
    userEventId() {
      return this.messagePreviewData?.userEventId
    },
    componentName() {
      switch (this.messagePreviewData?.type) {
        case 'blockingreason':
          return 'BlockingreasonModalContent'
        case 'backorder':
          return 'BackorderModalContent'
        default:
          return ''
      }
    },
    initialRead() {
      return this.messagePreviewData?.read
    },
  },
  watch: {
    messagePreviewData: {
      handler() {
        if (this.dialogData && this.componentName) {
          this.dialog = true
        } else {
          this.dialog = false
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(STORE_MODULES.MESSAGES, {
      setMessagePreview: MESSAGES_ACTIONS.SET_CURRENT_MESSAGE_PREVIEW,
    }),
    ...mapActions(STORE_MODULES.APP, {
      removeNotification: APP_ACTIONS.REMOVE_NOTIFICATION,
    }),
    closeDialog() {
      this.setMessagePreview(undefined)
    },
  },
}
</script>

<style lang="scss" module></style>
